

































import Super from "@/pv4-super-class"
import { Component } from "vue-property-decorator"

import TaskOverview from "./TaskAllEvent.vue"
import TaskMy from "./TaskMy.vue"
import TaskAssigned from "./TaskAssigned.vue"

@Component({
  components: {
    TaskOverview,
    TaskMy,
    TaskAssigned
  }
})
export default class Task extends Super {}
